import { Benefit } from '@pxtra-client-lib-legacy/types';
import { cn } from '../../../../util';
import { useTranslation } from 'react-i18next';
import { BenefitIcon } from '../../../compound/dataDisplay';
import { CheckmarkCircleFilledIcon } from '../../../../icons';

export interface BenefitButtonProps {
  benefit: Benefit;
  isSelected?: boolean;
  width?: number;
  disabled?: boolean;
  onToggle?: (benefit: Benefit) => void;
}

const getCardStyles = (isSelected?: boolean) => {
  return cn(
    'h-[144px] relative flex flex-col items-center bg-white hover:bg-heaven-100 border border-solid border-grey-200 rounded-xl cursor-pointer',
    isSelected && 'border-heaven-600'
  );
};

export const BenefitButton = ({
  benefit,
  isSelected = false,
  width,
  disabled,
  onToggle
}: BenefitButtonProps) => {
  const { t } = useTranslation();
  return (
    <button
      onClick={() => onToggle?.(benefit)}
      className={getCardStyles(isSelected)}
      style={width ? { width: `${width}px` } : undefined}
      disabled={disabled}
    >
      {isSelected && (
        <div className="absolute top-3 right-3">
          <CheckmarkCircleFilledIcon width={24} height={24} className="text-heaven-600" />
        </div>
      )}
      <div className="h-[72px] w-[196px] m-auto flex flex-col gap-2 items-center">
        <BenefitIcon benefitKey={benefit} size={40} color="primary" backgroundColor="transparent" />
        <div className="min-w-[194px] leading-6 text-center">{t(`benefits:${benefit}`)}</div>
      </div>
    </button>
  );
};
